export default function gerarIdRudimentar(): string {
    const timestamp = new Date().getTime();
    const numeroAleatorio = Math.random() * 1000000000;
    return `${timestamp}-${numeroAleatorio}`;
}